import React from 'react';
import { DocumentFileIcon } from '@assets/icons';
import {
  Box,
  Alert,
  AlertTitle,
  IconButton,
  DeleteIcon,
  AlertDescription,
  CheckCircleIcon,
  Tag,
  Flex,
} from 'ui';
import { DOCUMENT } from '@config/constants';
import { tscope } from '@i18n/index';
import { styles as s } from './FileAlert.styles';

export const ts = tscope('Requisition.documents.generic');

const approved = DOCUMENT.ANALYST_STATUS.APPROVED;
const pending = DOCUMENT.ANALYST_STATUS.PENDING;

const getIcon = ({ status }) => ({
  [approved]: <CheckCircleIcon color="blue.500" {...s.alertIcon} data-testid={`${approved}-icon`} />,
  [pending]: <DocumentFileIcon color="green.500" {...s.alertIcon} data-testid={`${pending}-icon`} />,
  warning: <DocumentFileIcon color="yellow.500" data-testid="warning-icon" {...s.alertIcon} />,
})[status];

export const FileAlert = ({
  fileName,
  isLoading,
  onRemoveFile,
  status = DOCUMENT.ANALYST_STATUS.PENDING,
  storageServiceStatus = DOCUMENT.STATUS.PENDING,
}) => {
  let alertStatus;
  let displayDescription = false;

  if (storageServiceStatus === DOCUMENT.STATUS.PENDING) {
    alertStatus = 'warning';
    displayDescription = true;
  } else {
    alertStatus = status;
  }

  return (
    <Alert
      {...s.alert}
      {...s[`${alertStatus}`]}
      data-testid={`${alertStatus}-alert`}
    >
      <Box>
        {getIcon({ status: alertStatus })}
      </Box>
      <AlertTitle {...s.alertTitle}>
        {fileName}
      </AlertTitle>
      <Flex {...s.descriptionBox}>
        {displayDescription && (
          <Tag {...s.processing}>
            {ts('processing')}
          </Tag>
        )}
        {status.includes(pending) && (
          <AlertDescription {...s.alertDescription}>
            <IconButton
              data-testid="deleteButton"
              {...s.iconButton}
              isLoading={isLoading}
              onClick={onRemoveFile}
              icon={<DeleteIcon color="gray.400" />}
            />
          </AlertDescription>
        )}
      </Flex>
    </Alert>
  );
};
